module.exports = __webpack_public_path__ + "cf6613d1adf490972c557a8e318e0868.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-700.woff
// module id = 672
// module chunks = 0